




















































import { Component } from 'vue-property-decorator';
import Routes from '@/util/Routes';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import AbstractFlyoutMenu from '@/views/layout/AbstractFlyoutMenu';
import { getModule } from 'vuex-module-decorators';
import { CmsStore } from '@/stores/cms.store';
import { FlyoutCategoryDto, HighlightLinkDto, LinkDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';

@Component({
  components: {CmsLink, LoadingIndicator},
})
export default class FlyoutMenu extends AbstractFlyoutMenu {
  private cmsStore = getModule(CmsStore, this.$store);
  private loading = true;
  private routes = Routes;

  get extraLinksTitle(): string {
    return this.cmsStore.header?.flyoutLinksTitle ?? '';
  }

  get extraLinks(): LinkDto[] {
    return this.cmsStore.header?.flyoutLinks ?? [];
  }

  get highlightsTitle(): string {
    return this.cmsStore.header?.flyoutHighlightsTitle ?? '';
  }

  get highlights(): HighlightLinkDto[] {
    return this.cmsStore.header?.flyoutHighlights ?? [];
  }

  get categoryImages(): FlyoutCategoryDto[] {
    return this.cmsStore.header?.flyoutCategories ?? [];
  }

  public getBackgroundStyleForCategory(categoryId: string): string {
    const backgroundImagePath = this.getBackgroundImagePathForCategory(categoryId);
    if(backgroundImagePath) {
      return `background-image: url("${backgroundImagePath}");`;
    }

    return '';
  }

  private getBackgroundImagePathForCategory(categoryId: string): string | undefined {
    return this.categoryImages.find((category) => category.categoryId === categoryId)?.imagePath;
  }

  private getSubCategoryOf(categoryId: string) {
    return this.categoryStore.categories.filter((cats) => cats.category.parentId === categoryId);
  }

  private close(): void {
    this.$emit('close');
  }

  public async mounted() {
    if (this.categoryStore.categories.length === 0) {
      await this.categoryStore.fetchAllCategories();
    }
    this.loading = false;
  }
}
